export default (num: number | null | undefined): string => {
  if (!num && num !== 0) {
    return '0'
  }

  return new Intl.NumberFormat('es-ES', {
    useGrouping: true,
  }).format(num)
}
